import {
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
} from "@mui/material";
import { Table } from "react-bootstrap";
import { ProgramDetail } from "src/types/affiliatePrograms";
import { InfiniteScrollList } from "../infiniteScroll";

type Props = {
  programs: ProgramDetail[];
  hasMore: boolean;
  loadMore: () => void;
  loadingMore: boolean;
};

export const AffiliateProgramsTable = ({
  programs,
  hasMore,
  loadMore,
  loadingMore,
}: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ overflow: "visible" }}
      className="table-container"
    >
      <Table>
        <TableHead
          sx={{
            position: "sticky",
            top: 60,
            zIndex: 30,
            borderTopLeftRadius: 5,
          }}
        >
          <TableRow>
            <TableCell
              sx={{ borderTopLeftRadius: 12 }}
              className="css-mlny8k MuiTableCell-head"
            >
              Program Number
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Program Name
            </TableCell>
            <TableCell align="center" className="css-mlny8k MuiTableCell-head">
              Program Type
            </TableCell>
            <TableCell align="center" className="css-mlny8k MuiTableCell-head">
              Product Name
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Patient ID
            </TableCell>
            <TableCell align="center" className="css-mlny8k MuiTableCell-head">
              Receipt Nr
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Events Reported
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Response Received
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Response Received Date
            </TableCell>
            <TableCell className="css-mlny8k MuiTableCell-head">
              Country
            </TableCell>
            <TableCell
              sx={{ borderTopRightRadius: 12 }}
              className="css-mlny8k MuiTableCell-head"
            >
              Submitted By
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {programs.length > 0 ? (
            <InfiniteScrollList<ProgramDetail>
              items={programs}
              renderItem={(row, index) => (
                <TableRow key={index}>
                  <TableCell className="css-mlny8k">
                    {row.program_number}
                  </TableCell>
                  <TableCell className="css-mlny8k">{row.program}</TableCell>
                  <TableCell align="center" className="css-mlny8k">
                    {row.program_type}
                  </TableCell>
                  <TableCell align="center" className="css-mlny8k">
                    {row.products}
                  </TableCell>
                  <TableCell className="css-mlny8k">{row.patient_id}</TableCell>
                  <TableCell align="center" className="css-mlny8k">
                    {row.lrn ?? "-"}
                  </TableCell>
                  <TableCell
                    sx={{ maxWidth: "30vw", wordWrap: "break-word" }}
                    className="css-mlny8k"
                  >
                    {row.events_reported ?? "-"}
                  </TableCell>
                  <TableCell className="css-mlny8k">
                    {row.date_of_response_received ? "Yes" : "No"}
                  </TableCell>
                  <TableCell className="css-mlny8k">
                    {row.date_of_response_received ?? "-"}
                  </TableCell>
                  <TableCell className="css-mlny8k">{row.country}</TableCell>
                  <TableCell className="css-mlny8k">
                    {row.date_of_response_received
                      ? row.submittedBy || row.tpEmailId
                      : row.tpEmailId}
                  </TableCell>
                </TableRow>
              )}
              hasMore={hasMore}
              loadMore={() => {
                console.log("Load more");
                loadMore();
              }}
              loading={loadingMore}
            />
          ) : (
            <TableRow>
              <TableCell colSpan={7} style={{ textAlign: "center" }}>
                No records found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
